import { render, staticRenderFns } from "./ParcelasTabela.vue?vue&type=template&id=6b483086&scoped=true"
import script from "./ParcelasTabela.vue?vue&type=script&setup=true&lang=js"
export * from "./ParcelasTabela.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ParcelasTabela.vue?vue&type=style&index=0&id=6b483086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b483086",
  null
  
)

export default component.exports